import React from 'react';
import { RouteObject } from 'react-router-dom';
import { getRouteConfig } from './routeConfig';

// Route configuration based on environment
export const getRoutes = (
  isAuthenticated: boolean,
  handleLogin: (token: string) => void,
  handleLogout: () => void
): RouteObject[] => {
  const config = getRouteConfig();
  return config.getRoutes(isAuthenticated, handleLogin, handleLogout);
};

export { getRouteConfig } from './routeConfig';